// Raw validity patterns with no validation library attached, so the browser can
// check a field without downloading yup (~42KB) on the marketing landing page.
// `validations.ts` builds its schemas from these — do not inline a second copy.

/** RFC 5321's practical ceiling. */
export const EMAIL_MAX_LENGTH = 254;

export const EMAIL_REGEX =
  /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
